export default "__VITE_ASSET__C4c7dIyV__"